"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var aggregate = tslib_1.__importStar(require("./aggregate"));
exports.aggregate = aggregate;
var axis = tslib_1.__importStar(require("./axis"));
exports.axis = axis;
var bin = tslib_1.__importStar(require("./bin"));
exports.bin = bin;
var channel = tslib_1.__importStar(require("./channel"));
exports.channel = channel;
var compositeMark = tslib_1.__importStar(require("./compositemark"));
exports.compositeMark = compositeMark;
var compile_1 = require("./compile/compile");
exports.compile = compile_1.compile;
var config = tslib_1.__importStar(require("./config"));
exports.config = config;
var data = tslib_1.__importStar(require("./data"));
exports.data = data;
var datetime = tslib_1.__importStar(require("./datetime"));
exports.datetime = datetime;
var encoding = tslib_1.__importStar(require("./encoding"));
exports.encoding = encoding;
var facet = tslib_1.__importStar(require("./facet"));
exports.facet = facet;
var fieldDef = tslib_1.__importStar(require("./fielddef"));
exports.fieldDef = fieldDef;
var header = tslib_1.__importStar(require("./header"));
exports.header = header;
var legend = tslib_1.__importStar(require("./legend"));
exports.legend = legend;
var mark = tslib_1.__importStar(require("./mark"));
exports.mark = mark;
var scale = tslib_1.__importStar(require("./scale"));
exports.scale = scale;
var sort = tslib_1.__importStar(require("./sort"));
exports.sort = sort;
var spec = tslib_1.__importStar(require("./spec"));
exports.spec = spec;
var stack = tslib_1.__importStar(require("./stack"));
exports.stack = stack;
var timeUnit = tslib_1.__importStar(require("./timeunit"));
exports.timeUnit = timeUnit;
var transform = tslib_1.__importStar(require("./transform"));
exports.transform = transform;
var type = tslib_1.__importStar(require("./type"));
exports.type = type;
var util = tslib_1.__importStar(require("./util"));
exports.util = util;
var validate = tslib_1.__importStar(require("./validate"));
exports.validate = validate;
var package_json_1 = tslib_1.__importDefault(require("../package.json"));
var version = package_json_1.default.version;
exports.version = version;
//# sourceMappingURL=index.js.map